module.exports = __webpack_public_path__ + "img/poop-1.b237f771.png";